const initObserverForElement = (elementId) => {
    const targetNode = document.getElementById(elementId);
    
    if (!targetNode) return;

    if (targetNode.innerHTML.trim() !== "" && targetNode.classList.contains("d-none")) {
        targetNode.classList.remove("d-none");
        return;
    }

    const callback = function (mutationsList, observer) {
        for (const mutation of mutationsList) {
            if (mutation.type === "childList" && mutation.addedNodes.length > 0 && targetNode.classList.contains("d-none")) {
                targetNode.classList.remove("d-none");
                observer.disconnect();
            }
        }
    };

    const observer = new MutationObserver(callback);
    const config = { childList: true };
    observer.observe(targetNode, config);
};

const init = () => {
    const idsToObserve = ["col-search-top-content-container", "col-search-bottom-content-container", "zu-search-top-content-container", "zu-search-bottom-content-container"];
    idsToObserve.forEach(id => initObserverForElement(id));
};

export { init };
